import type { HTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { classNames } from '@/ui/utils/main'

const Skeleton = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, fwdRef) => (
    <div
      ref={fwdRef}
      className={classNames('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  ),
)
Skeleton.displayName = 'Skeleton'

export { Skeleton }
